import Sentry from "@common/components/thirdParty/Sentry";
import { ReactElement } from "react";
import { useAccount } from "@stores/session/hooks";

export function SentryContainer(): ReactElement {
  const account = useAccount();

  return <Sentry account={account && { id: account.id }} />;
}
